import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Farm from "@/pages/Farm";
import Gallery from "@/pages/Gallery";
import Stay from "@/pages/Stay";
import ShadowFoundation from "@/pages/ShadowFoundation";
import NewLeaf from "@/pages/NewLeaf";
import Visit from "@/pages/Visit";
import Amenities from "@/pages/Amenities";
import LocalGuide from "@/pages/LocalGuide";
import Donate from "@/pages/Donate";
import DonationSuccess from "@/pages/DonationSuccess";
import FontPreview from "@/pages/FontPreview";
import Book from "@/pages/Book";
import BookConfirmed from "@/pages/BookConfirmed";
import Terms from "@/pages/Terms";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/farm" element={<Farm />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/stay" element={<Stay />} />
            <Route path="/shadow-foundation" element={<ShadowFoundation />} />
            <Route path="/shadow-foundation/apply" element={<ShadowFoundation />} />
            <Route path="/new-leaf" element={<NewLeaf />} />
            <Route path="/new-leaf/interest" element={<NewLeaf />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/amenities" element={<Amenities />} />
            <Route path="/local-guide" element={<LocalGuide />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donate/success" element={<DonationSuccess />} />
            <Route path="/font-preview" element={<FontPreview />} />
            <Route path="/book" element={<Book />} />
            <Route path="/book/:slug" element={<Book />} />
            <Route path="/book/confirmed/:id" element={<BookConfirmed />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/bookings" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
